import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import OTPInput from "react-otp-input";
import { useState } from "react";

const OtpVerification = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState<string>("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (otp.length === 0) {
      navigate("/reset-password");
    } else {
      alert("Please enter a valid 4-digit OTP");
    }
  };

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Verify Your Email</h2>
        <p>We have Sent OTP to info@example.com to verify your email address and activate your account entering the OTP</p>

        <form className="form" onSubmit={handleSubmit}>
          <div className="control_group">
            <div className="opt_fields">
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                renderInput={(props) => <input {...props} id="otp" />}
                inputType="tel"
                shouldAutoFocus
              />
            </div>
            <div className="auth_bottom">
              <p>
                <button type="button" className="link">
                  Resend OTP (30s)
                </button>
              </p>
            </div>
          </div>
          <div className="form_btn">
            <Button
              type="submit"
              className="btn btn_primary w_100"
            >
              Reset Password
            </Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p>
            <button className="link" onClick={() => navigate("/")}>
              <KeyboardBackspaceIcon /> Return to Login
            </button>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default OtpVerification;
